import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FairForm2Service } from 'src/app/components/fair-form2/fair-form2.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'app-fair-form2',
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule
    ],
    templateUrl: './fair-form2.component.html',
    styleUrl: './fair-form2.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FairForm2Component {
  readonly #fairFormService = inject(FairForm2Service);

  @Input({ required: true }) redirect!: string;

  readonly form = new FormGroup({
    name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    phone: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    hopeTime: new FormControl('第1回 10:00 受付 9:30～', { nonNullable: true, validators: [Validators.required] }),
    attendType: new FormControl('現地参加を希望する', { nonNullable: true, validators: [Validators.required] })
  });

  submit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.#fairFormService.submit(this.form.value)
        .subscribe(() => {
          window.location.href = this.redirect;
        });
    }
  }
}
